/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Timezone
 */
export interface Timezone {
    /**
     * 
     * @type {string}
     * @memberof Timezone
     */
    offset: string;
}

/**
 * Check if a given object implements the Timezone interface.
 */
export function instanceOfTimezone(value: object): value is Timezone {
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function TimezoneFromJSON(json: any): Timezone {
    return TimezoneFromJSONTyped(json, false);
}

export function TimezoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Timezone {
    if (json == null) {
        return json;
    }
    return {
        
        'offset': json['offset'],
    };
}

export function TimezoneToJSON(json: any): Timezone {
    return TimezoneToJSONTyped(json, false);
}

export function TimezoneToJSONTyped(value?: Timezone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offset': value['offset'],
    };
}

